import { useQuery } from '@tanstack/react-query'
import { FRAUD_CASE_DETAILS, FRAUD_CASES } from 'api/react-query/keys'
import type { ListFraudCasesParams } from '../types'
import { getFraudCaseDetails, listFraudCases } from './endpoints'

export const useFraudCases = (params?: ListFraudCasesParams) => {
  const query = useQuery({
    queryKey: [FRAUD_CASES, params],
    queryFn: () => listFraudCases(params),
    keepPreviousData: true,
    select: (response) => ({ cases: response.data, pagination: response.pagination }),
  })
  return query
}

export const useFraudCaseDetails = (fraudCaseId: string | undefined) => {
  return useQuery({
    queryKey: [FRAUD_CASE_DETAILS, fraudCaseId],
    queryFn: () => getFraudCaseDetails(fraudCaseId as string),
    enabled: !!fraudCaseId,
    select: (response) => response.data,
  })
}
